import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../lib/i18n";
import { imageUrl } from "../lib/adminApi";
import { Overline } from "./ui-vision";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STR = {
  fr: { overline: "Nos réalisations", all: "Voir toutes nos réalisations" },
  nl: { overline: "Onze realisaties", all: "Alle realisaties bekijken" },
};

export const RealisationsPreview = () => {
  const { lang } = useLang();
  const s = STR[lang];
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(`${API}/projects`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setProjects(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  if (projects.length === 0) return null;

  const featured = projects.filter((p) => p.featured);
  const list = (featured.length >= 3 ? featured : [...featured, ...projects.filter((p) => !p.featured)]).slice(0, 3);

  return (
    <section className="pt-12 md:pt-[50px] pb-6 md:pb-[50px] max-w-[1440px] mx-auto px-6 md:px-12" data-testid="realisations-preview">
      <div className="flex items-end justify-between gap-6 mb-8 md:mb-10">
        <Overline>{s.overline}</Overline>
        <Link
          to="/realisations"
          data-testid="realisations-preview-all"
          className="group inline-flex items-center gap-2 text-sm text-white/60 hover:text-accent-yellow transition-colors duration-300 whitespace-nowrap"
        >
          {s.all}
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-6 md:gap-8">
        {list.map((p, i) => (
          <Link
            key={p.id}
            to="/realisations"
            data-testid={`realisations-preview-card-${i}`}
            className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden hover:border-white/20 transition-colors duration-300"
          >
            <div className="relative overflow-hidden aspect-[16/10] bg-white/[0.04]">
              {p.image_id && (
                <img
                  src={imageUrl(p.image_id)}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
                />
              )}
            </div>
            <div className="p-5">
              {p.type?.[lang] && <span className="text-xs uppercase tracking-[0.25em] text-accent-yellow">{p.type[lang]}</span>}
              <h3 className="mt-2 font-display text-lg md:text-xl font-medium tracking-tight leading-tight">{p.title}</h3>
              {p.loc && <p className="mt-1 text-sm text-white/45">{p.loc}</p>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
